export default __webpack_public_path__ + "static/media/symbols_fr.2b94e778.png";